export enum IFormType {
  Create,
  Update,
  View,
  Sign,
  Duplicate,
}
